import { CodeBlockItem } from '@/components/organisms/codeBlock/CodeBlockItem';

import { ResponseFormatView } from './constants/response-formats';

export const HTMLResponseView = ({
  viewType,
  data,
}: {
  viewType: ResponseFormatView;
  data: any;
}) => {
  const content: string = data?.results[0].content;

  if (viewType === 'rich') {
    return (
      <iframe
        className='h-full w-full'
        sandbox='allow-forms allow-scripts'
        srcDoc={content}
      />
    );
  }
  return (
    <CodeBlockItem
      code={content ? content.substring(0, 10_000) + '...truncated' : ''}
      language='HTML'
    />
  );
};
